import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, Checkbox, Divider, FormControl, FormControlLabel, IconButton, MenuItem, Stack, Switch, TextField, Typography } from '@mui/material'
import { RootState } from '../../../global/config/store.ts';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ApiCreateNewBundleAllocation, ApiGetAllocationlist, ApiGetClientEntityByClientGroupId, ApiGetNewBundleList, ApiGetOrphanAllocations, ApiGetVisitTimes, ApiUpdateNewBundleAllocation } from '../../../apiService/Core/Apicall.tsx';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { format } from 'date-fns';
import { CancelOutlined } from '@mui/icons-material';
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';
import { toast } from 'react-toastify';
import { setDate } from '../../../global/config/Reducer/dateSlice.ts';

function CreateOrUpdateNewBundleAllocation() {
    const location = useLocation();
    // const bundleData = location.state?.bundleData;
    // const currentData = location.state?.currentDate;
    const { id, currentdate } = useParams()
    const [bundleData, setBundleData] = useState<any>()
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch()
    const [clientEntityList, setClientEntityList] = useState<any>([]);
    const [clientEntityId, setClientEntityId] = useState<any>(null);
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
    const [ClientId, setClientId] = useState(null);
    const [currentDate, setCurrentDate] = useState(currentdate ? new Date(currentdate) : new Date(selectedDateRedux));
    const [reportMonth, setReportMonth] = useState<number>(currentDate.getMonth() + 1);
    const [reportYear, setReportYear] = useState<number>(currentDate.getFullYear());
    const [checkboxes, setCheckboxes] = React.useState<any[]>([]);
    const [task, settask] = React.useState<any[]>([]);
    const [visitTimes, setVisitTimes] = useState<any[]>([]);
    const [visitTimesValues, setVisitTimesValues] = useState<any[]>(bundleData ? bundleData?.bundleVisitTimeInformation?.split(",") : []);
    const [isActive, setIsActive] = useState(bundleData ? bundleData?.isNeedToSelectDate : false);
    const [bundleTasks, setbundleTasks] = React.useState<any[]>([]);
    const [fromDate, setFromDate] = useState(bundleData ? bundleData?.bundleMinDate : "");
    const [toDate, setToDate] = useState(bundleData ? bundleData?.bundleMaxDate : "");
    const [bundleName, setbundleName] = React.useState<string>(bundleData && bundleData?.bundleName ? bundleData?.bundleName : '');
    const navigate = useNavigate()


    const ApiBundleAllocation = async () => {
        settask([]);
        const data = `?month=${reportMonth}&year=${reportYear}&bundleId=${id}`
        try {
            const response = await ApiGetNewBundleList(data)
            setBundleData(response.data[0])
            setVisitTimesValues(response?.data[0]?.bundleVisitTimeInformation?.split(","))
            setIsActive(response?.data[0]?.isNeedToSelectDate)
            setFromDate(response?.data[0]?.bundleMinDate)
            setToDate(response?.data[0]?.bundleMaxDate)
            setbundleName(response?.data[0]?.bundleName)

        } catch (error:any) {
            toast.error(error)
        }

    }

    useEffect(() => {
       id && reportMonth && reportYear && ApiBundleAllocation()
    }, [id])

    useEffect(() => {
        if (bundleData?.bundleId > 0 && bundleData.allocations) {
            const tasks = bundleData.allocations.map((item: any) => ({
                allocationId: item?.allocationId,
                differentiateKey: item?.differentiateKey,
                entityName: item?.clientEntityId?.entityName,
                venueId: item?.venueId?.venueId,
                venueName: item?.venueId?.venueName,
            }));
            setbundleTasks(tasks);
        }
    }, [bundleData]);

    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])

    const handleChange = (key: string | number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        setCheckboxes((prev) => ({
            ...prev,
            [key]: checked
        }));
        if (!checked) {
            setbundleTasks((prev) =>
                prev.filter((item) => item.allocationId !== key)
            );
        }
    };

    useEffect(() => {
        bundleData?.allocations?.map((item: any) => {
            setCheckboxes((prev) => (
                {
                    ...prev,
                    [item?.allocationId]: true

                }));
        })

    }, [bundleData])


    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2]);
            setClientId(Clientlist[2].clientGroupName);
        }
    }, [Clientlist]);

    useEffect(() => {
        if (clientEntityList.length > 1) {
            setClientEntityId(clientEntityList[0]?.clientEntityId);
        }
    }, [clientEntityList]);

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])

    useEffect(() => {
        // settask([])
        if (!clientEntityId) {
            settask([])
            return;
        }
        const getallocationlist = async () => {
            if (clientEntityId) {
                // const data = `?allocationStatus=created&offset=0&limit=1000&jobMonth=${reportMonth}&jobYear=${reportYear}&allocationClientGroup=${selectedClient?.clientGroupName}&clientEntityId=${clientEntityId}`
                const data = `?offset=0&limit=1000&jobMonth=${reportMonth}&jobYear=${reportYear}&allocationStatus=created&allocationClientGroup=${selectedClient?.clientGroupName}${clientEntityId ? `&clientEntityId=${clientEntityId}` : ""}`
                try {
                    const response = await ApiGetAllocationlist(data)
                    const filteredAllocations = response.data.filter((allocation: any) => allocation.withoutVenueBundleAllocationId === null)
                    settask(filteredAllocations)

                } catch (error) {
                    alert(error)
                }
            }
        }
        getallocationlist()
    }, [reportMonth, reportYear, clientEntityId, selectedClient])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`;
        if (!selectedClient?.clientGroupName) return;
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data);
            setClientEntityList(res.data);
        } catch (error) {
        }
    };

    const handlePrevMonth = () => {
        if (bundleTasks.length > 0) {
            const isEmptyBundle = window.confirm("You will loose your currunt Bulndle alocation list");

            if (isEmptyBundle) {
                setCurrentDate((prevDate: any) => {
                    const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
                    setReportMonth(newDate.getMonth() + 1);
                    setReportYear(newDate.getFullYear());
                    dispatch(setDate(newDate))
                    return newDate;
                });
                setbundleTasks([])
            }
        }
        else {
            setCurrentDate((prevDate: any) => {
                const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
                setReportMonth(newDate.getMonth() + 1);
                setReportYear(newDate.getFullYear());
                dispatch(setDate(newDate))
                return newDate;
            });
        }
    };

    const handleNextMonth = () => {
        if (bundleTasks.length > 0) {
            const isEmptyBundle = window.confirm("You will loose your currunt Bulndle alocation list");
            if (isEmptyBundle) {
                setCurrentDate((prevDate: any) => {
                    const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
                    setReportMonth(newDate.getMonth() + 1);
                    setReportYear(newDate.getFullYear());
                    dispatch(setDate(newDate))
                    return newDate;
                });
                setbundleTasks([])
            }
        }
        else {
            setCurrentDate((prevDate: any) => {
                const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
                setReportMonth(newDate.getMonth() + 1);
                setReportYear(newDate.getFullYear());
                dispatch(setDate(newDate))
                return newDate;
            });
        }
    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01");
        if (bundleTasks.length > 0) {
            const isEmptyBundle = window.confirm("You will loose your currunt Bulndle alocation list");
            if (isEmptyBundle) {
                setCurrentDate(newDate);
                setReportMonth(newDate.getMonth() + 1);
                setReportYear(newDate.getFullYear());
                dispatch(setDate(event.target.value))
                setbundleTasks([])
            }
        }
        else {
            setCurrentDate(newDate);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            dispatch(setDate(event.target.value))
        }
    };

    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])

    // useEffect(() => {
    //     const filtered = task.filter((item) =>
    //         checkboxes[item?.allocationId]
    //     );

    //     setbundleTasks(
    //         filtered.map((item) => ({
    //             allocationId: item.allocationId,
    //             venueId: item?.venueId?.venueId || null,
    //             entityName: item?.clientEntityId.entityName || null,
    //             differentiateKey: item?.differentiateKey || null,
    //             venueName: item?.venueId?.venueName
    //                 ? item?.venueId.venueName
    //                 : `${item?.clientEntityId?.entityName}-${item?.differentiateKey}`,
    //             // taskName: item.taskName,
    //         }))
    //     );
    // }, [checkboxes, task]);


    // useEffect(() => {
    // const selectedFromTasks = task
    //     .filter((item) => checkboxes[item?.allocationId])
    //     .map((item) => ({
    //         allocationId: item.allocationId,
    //         venueId: item?.venueId?.venueId,
    //         venueName: item?.venueId?.venueName,
    //         // taskName: item.taskName,
    //         entityName: item?.clientEntityId.entityName,
    //         differentiateKey: item?.differentiateKey
    //     }));

    // const selectedFromBundleData = (bundleData?.allocations || [])
    //     .filter((item: any) => checkboxes[item?.allocationId])
    //     .map((item: any) => ({
    //         allocationId: item.allocationId,
    //         venueId: item?.venueId?.venueId,
    //         venueName: item?.venueId?.venueName,
    //         // taskName: item.taskName,
    //         entityName: item?.clientEntityId.entityName,
    //         differentiateKey: item?.differentiateKey
    //     }));

    //     const merged = new Map();
    //     [...selectedFromTasks, ...selectedFromBundleData].forEach((item) =>
    //         merged.set(item?.allocationId, item)
    //     );

    //     setbundleTasks(Array.from(merged.values()));
    // }, [checkboxes, task, bundleData]);

    useEffect(() => {

        const selectedFromTasks = task
            .filter((item) => checkboxes[item?.allocationId])
            .map((item) => ({
                allocationId: item.allocationId,
                venueId: item?.venueId?.venueId,
                venueName: item?.venueId?.venueName,
                entityName: item?.clientEntityId.entityName,
                differentiateKey: item?.differentiateKey
            }));

        const selectedFromBundleData = (bundleData?.allocations || [])
            .filter((item: any) => checkboxes[item?.allocationId])
            .map((item: any) => ({
                allocationId: item.allocationId,
                venueId: item?.venueId?.venueId,
                venueName: item?.venueId?.venueName,
                entityName: item?.clientEntityId.entityName,
                differentiateKey: item?.differentiateKey
            }));
        setbundleTasks((prev) => {
            const merged = [...prev, ...selectedFromTasks, ...selectedFromBundleData];
            return merged.filter(
                (item, index, self) =>
                    index === self.findIndex((t) => t.allocationId === item.allocationId)
            );
        });

    }, [task, checkboxes, bundleData])



    const removeBundle = (key: string | number) => {
        const filteredBundle = bundleTasks.filter(
            (item) =>
                (item?.allocationId) !== key
        );

        setbundleTasks(filteredBundle);

        setCheckboxes((prev) => ({
            ...prev,
            [key]: false,
        }));
    };


    const createbundle = async () => {
        if (bundleName !== '' && bundleTasks.length > 0) {
            const data = {
                bundleName: bundleName,
                month: reportMonth,
                year: reportYear,
                allocationIds: bundleTasks.map(item => item.allocationId),
                isNeedToSelectDate: isActive,
                visitTimeInformation: visitTimesValues.length > 1 ? visitTimesValues?.join(",") : visitTimesValues,
                minDate: fromDate,
                maxDate: toDate,
                createdBy: Number(localStorage.getItem("userId"))
            }
            const data2 = {
                bundleName: bundleName,
                month: reportMonth,
                year: reportYear,
                allocationIds: bundleTasks.map(item => item.allocationId),
                isNeedToSelectDate: isActive,
                visitTimeInformation: visitTimesValues.length > 1 ? visitTimesValues?.join(",") : visitTimesValues,
                minDate: fromDate,
                maxDate: toDate
            }
            try {
                let response;

                if (bundleData) {
                    //  Update bundle
                    response = await ApiUpdateNewBundleAllocation({
                        ...data2,
                        bundleId: bundleData?.bundleId,
                    });
                    toast.success("Updated Successfully.")
                    if (response.status) {
                        navigate('/admin/allocations/newBundle-allocations');
                    }
                } else {
                    //  Create new bundle
                    try {
                        response = await ApiCreateNewBundleAllocation(data);
                        toast.success(response.message);
                        if (response.status) {
                            navigate('/admin/allocations/newBundle-allocations');
                        }
                    } catch (error) {
                        console.error("Error Creating Bundle.", error);
                        toast.error("Error Creating Bundle.")
                    }
                }

            } catch (error) {
                console.error("Error ")
            }
            console.log("Send Data", data)
            console.log("Send Data2", data2)
        }
        else if (bundleName == '') {
            alert('Enter Bundle Name')
        }
        else if (bundleTasks.length == 0) {
            alert('Select allocations to create bundle')
        }
    }

    const handleGetVisitTimeList = async () => {
        try {
            const response: any = await ApiGetVisitTimes();
            setVisitTimes(response.data);
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };
    useEffect(() => {
        handleGetVisitTimeList()
    }, [])

    // useEffect(() => {
    //     const checkedTasks = task
    //         .filter((item) => checkboxes[item?.allocationId])
    //         .map((item) => ({
    //             allocationId: item.allocationId,
    //             venueId: item?.venueId?.venueId,
    //             venueName: item?.venueId?.venueName,
    //             entityName: item?.clientEntityId.entityName,
    //             differentiateKey: item?.differentiateKey
    //         }));

    //     setbundleTasks(checkedTasks);

    // }, [task, checkboxes, bundleData]) 
    // ...
    // console.log('Bundle Tasks', bundleTasks)
    return (
        <Box className='bg-white pt-5'>
            <div className="d-flex align-items-center justify-content-between px-3 mb-1">
                <Box className='d-flex align-items-center gap-5'>
                    <Stack direction="row" className="" spacing={2}>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={Clientlist}
                                value={selectedClient}
                                getOptionLabel={(option) => option?.clientGroupName}
                                isOptionEqualToValue={(option, value) =>
                                    option.clientGroupDBName === value.clientGroupDBName
                                }
                                onChange={(event, newValue: any) => {
                                    // setSelectedClient(newValue);
                                    dispatch(setSelectedClientGroup(newValue))
                                    setClientId(newValue?.clientGroupName || null);
                                    setClientEntityId(null)
                                    setClientEntityList([])
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack className="ml-2" direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: { lg: 300, xl: 400 } }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={clientEntityList.filter(
                                    (item: any) => item.clientEntityId !== null
                                )}
                                getOptionLabel={(option) => option?.entityName || ""}
                                onChange={(event, newValue: any) => {
                                    setClientEntityId(newValue?.clientEntityId || null);
                                }}
                                value={
                                    clientEntityList.find(
                                        (option: any) => option?.clientEntityId === clientEntityId
                                    ) || null
                                }
                                defaultValue={clientEntityList[0]?.clientEntityId}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Business" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                </Box>
                <h1 className="">Transport Bundle Allocations</h1>

                {/* <Box className='col-6 d-flex juastify-content-start'> */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // marginTop: "20px"
                    }}
                >
                    <IconButton onClick={handlePrevMonth}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                        <input
                            type="month"
                            onChange={handleDateChange}
                            value={format(currentDate, "yyyy-MM")}
                            className="primary-color"
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "1.25rem",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontFamily: "inherit",
                            }}
                        />
                    </Box>
                    <IconButton onClick={handleNextMonth}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
            </div>
            <Divider className='mx-4 mb-2' />

            <Box height='calc(100vh - 380px)' className='d-flex align-items-start  justify-content-between'>
                <Box className='col-8 h-100 p-3'>
                    <Box className='d-flex flex-wrap align-items-center justify-content-start' maxHeight='calc(100vh - 450px)' overflow='auto' gap={2}>
                        {task.length > 0 ? task.map((item: any) => (
                            <Box className='border d-flex align-items-start p-2 col-3' sx={{ borderRadius: '10px' }} maxWidth='24%' gap={1} key={item.allocationId}>
                                <Checkbox
                                    className='m-0 p-0'
                                    checked={
                                        checkboxes[item?.allocationId] || false
                                    }
                                    onChange={handleChange(item?.allocationId)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                <Box>
                                    <Typography lineHeight='1' className='fw-bold m-0 p-0' variant='h6'>
                                        {item?.venueId?.venueName.length
                                            ? item?.venueId.venueName
                                            : `${item?.clientEntityId?.entityName}-${item?.differentiateKey}`}
                                    </Typography>
                                    <Typography className='m-0 p-0' variant='subtitle2'>{item.taskName}</Typography>
                                </Box>
                            </Box>

                        )) : <Typography variant='h6' className='text-center w-100'>Allocations not Found</Typography>}
                    </Box>
                </Box>
                <Divider orientation='vertical' />
                <Box className='col-4 h-100 p-3' overflow="auto">
                    <FormControl className="w-100 my-0 mb-3 ">
                        <TextField
                            className="w-100"
                            label="Bundle Name"
                            placeholder="Enter Bundle Name..."
                            variant="outlined"
                            fullWidth
                            value={bundleName}
                            onChange={(e) => setbundleName(e.target.value)}
                        />
                    </FormControl>
                    <Stack direction="row" className="" gap={1} mb={2}>
                        <FormControl className="w-100">
                            <TextField
                                select
                                label="From Date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                fullWidth
                            >
                                {[...Array(31)].map((_, i) => (
                                    <MenuItem key={i + 1} value={i + 1}>
                                        {i + 1}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </FormControl>
                        <FormControl className="w-100">
                            <TextField
                                select
                                label="To Date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                fullWidth
                            >
                                {[...Array(31)].map((_, i) => (
                                    <MenuItem key={i + 1} value={i + 1}>
                                        {i + 1}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </FormControl>
                    </Stack>
                    <Stack direction="row" gap={1} mb={2}>
                        <Autocomplete
                            multiple
                            options={visitTimes}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.visitTimeInformation}
                            value={visitTimes?.filter((time) => visitTimesValues?.includes(time.visitTimeId.toString()))}
                            onChange={(event, newValue) => {
                                setVisitTimesValues(newValue.map((item) => item.visitTimeId.toString()));
                            }}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox checked={visitTimesValues.includes(option.visitTimeId.toString())} style={{ marginRight: 8 }} />
                                    {option.visitTimeInformation}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Visit Times" />
                            )}
                            className="w-100"
                        />
                    </Stack>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isActive}
                                    onChange={(e) => setIsActive(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Can shopper select different date?"
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                m: 0,
                                width: "100%",
                            }}
                            labelPlacement="start"
                        />
                    </FormControl>
                    <Typography className='text-center mb-3' variant='h5'>Selected Allocation</Typography>
                    <Box className='d-flex flex-wrap align-items-center' maxHeight='calc(100vh - 450px)' overflow='auto' gap={1}>
                        {bundleTasks && bundleTasks.map(item => {
                            const displayName = item?.venueName
                                ? item?.venueName
                                : `${item?.entityName || ''}-${item?.differentiateKey || ''}`;
                            console.log("Show Bundle Task", bundleTasks)

                            return (
                                <Box
                                    className='border d-flex align-items-start justify-content-between p-3 col-6'
                                    sx={{ borderRadius: '10px' }}
                                    maxWidth='49%'
                                    key={item.allocationId}
                                >
                                    <Box>
                                        <Typography lineHeight='1' className='fw-bold m-0 p-0' variant='h6'>
                                            {displayName}
                                        </Typography>
                                        {/* <Typography className='m-0 p-0' variant='subtitle2'>{item.venueName}</Typography> */}
                                    </Box>
                                    <IconButton
                                        className='p-0'
                                        onClick={() => { removeBundle(item?.allocationId) }}
                                    >
                                        <CancelOutlined className='p-0' />
                                    </IconButton>
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>
            <Divider className='mx-4 my-3' />
            <Box className='d-flex px-3 align-items-center justify-content-end' gap={2}>
                <Box className='extra' mb={2}>
                    <Button className="bg-grey transform px-5 text-light" onClick={() => { createbundle() }}>
                        {bundleData ? `Update` : `Create`}
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default CreateOrUpdateNewBundleAllocation;
